import { BasicConfig } from '@shared/models/basic-config.interface';

export abstract class CollectionsConfig extends BasicConfig {
  privileges: {
    job: {
      teamMembers: {
        view: string;
        edit: string;
      };
    };
    hiringManager: string;
  };
}

export type CollectionsPrivileges = CollectionsConfig['privileges'];
